import * as React from "react";

function CloseIcon(props) {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.15625 7.80391C9.40234 8.07735 9.40234 8.4875 9.15625 8.7336C8.88281 9.00703 8.47266 9.00703 8.22656 8.7336L5 5.47969L1.74609 8.7336C1.47266 9.00703 1.0625 9.00703 0.816406 8.7336C0.542969 8.4875 0.542969 8.07735 0.816406 7.80391L4.07031 4.55L0.816406 1.2961C0.542969 1.02266 0.542969 0.612503 0.816406 0.366409C1.0625 0.0929718 1.47266 0.0929718 1.71875 0.366409L5 3.64766L8.25391 0.393753C8.5 0.120316 8.91016 0.120316 9.15625 0.393753C9.42969 0.639847 9.42969 1.05 9.15625 1.32344L5.90234 4.55L9.15625 7.80391Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoCloseIcon = React.memo(CloseIcon);
export default MemoCloseIcon;
